import { getAnalytics, isSupported } from "firebase/analytics";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyD-51NAJDOvTuioni0MdcpPP8bTjKbzJsc",
  authDomain: "peak-lattice-510513.firebaseapp.com",
  projectId: "peak-lattice-510513",
  storageBucket: "peak-lattice-510513.firebasestorage.app",
  messagingSenderId: "503455439070",
  appId: "1:503455439070:web:df2378565c8c4838058a4f",
  measurementId: "G-50GY8WQYM0",
};

export const app = initializeApp(firebaseConfig);

async function initAnalytics() {
  if (await isSupported()) {
    return getAnalytics(app);
  }
  return null;
}

export const analyticsPromise = initAnalytics();
